<label class="checkbox">
  <input type="checkbox" [(checked)]="checked" (change)="onChange()" />
  <div class="checkbox__checkmark"></div>
  <div class="checkbox__body"><ng-content /></div>
</label>
